<div class="col-md-12"
    style="box-shadow: 3px 3px 33px 6px #7500C0; height: 35vw;background: linear-gradient(141deg, #fafafa 20%, #fafafa 65%);">
    <div class="row">
        <div class="col-lg-12">
            <h3 class="page-header" style="color:#000000;"><i class="fa fa-laptop"></i> Dashboard</h3>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-8 col-md-12">
            <div class="panel panel-default" *ngIf="showDataMainDashboard" style="margin-top:-2%;">
                <div class="col-sm-6">
                    <div class="col-sm-4 formDivCaptions" style="width: 150px;">
                        <label style="color:black;font-weight:bold;">Device Type</label>
                    </div>
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-12 formDivTextBoxDropdownControls" style="margin-left:-8%;">
                                <label>Teams</label>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <br />
                <div>
                    <div class="panel-heading"
                        style="background: linear-gradient(141deg, #460073 20%, #A100FF 65%); font-weight: bold;  color: white; ">
                        <h2><i></i><strong>My Calls</strong></h2>
                        <div class="panel-actions">
                        </div>
                    </div>
                    <div class="panel-body" style="height:250px;margin-top:0%">
                        <table class="table bootstrap-datatable countries">
                            <thead>
                                <tr>
                                    <th style="color: #000000">
                                        <span class="tooltip">
                                            <img alt="" src="/assets/img/info2.jpg" class="img-circle"
                                                style="width: 8%; height: 6%; margin-bottom: -30px; margin-left: 40%;"/>
                                            <span class="tooltiptext"
                                                style="margin-bottom: -30%; margin-left: -47%; ">The types of call
                                                which was made by user.</span>
                                            </span>
                                        Call Type
                                    </th>
                                    <th style="color: #000000">
                                        <span class="tooltip">
                                            <img alt="" src="/assets/img/info2.jpg" class="img-circle"
                                                style="width: 8%; height: 6%; margin-bottom: -30px; margin-left: 40%;">
                                            <span class="tooltiptext"
                                                style="margin-bottom: -30%; margin-left: -17%; ">The total no. of
                                                calls with respect to call types for the current month.</span>
                                        </span>Count
                                    </th>
                                    <th style="color: #000000">
                                        <span class="tooltip">
                                            <img alt="" src="/assets/img/info2.jpg" class="img-circle"
                                                style="width: 8%; height: 6%; margin-bottom: -30px; margin-left: 40%;">
                                            <span class="tooltiptext"
                                                style="margin-bottom: -30%; margin-left: 13%; ">The total cost with
                                                respect to call types for the current month.</span>
                                        </span>Total Cost
                                    </th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let data of successfulData.mainDashboard">
                                <tr>
                                    <td>{{data.CallType}}</td>
                                    <td>{{data.Count}}</td>
                                    <td>{{data.Cost}}</td>
                                </tr>
                                <tr></tr>
                            </tbody>
                            <tfoot>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
            <div *ngIf="showMsgMainDashboard">
                <label
                    style="color:#000000; font-weight: bold; font-size: 15px;margin-left: 10px;">{{ErrorMessage}}</label>
            </div>
        </div>
        <div class="col-md-4" *ngIf="showDataMainDashboard">
            <div class="col-sm-12"
                style="font-family: Century; font-size: 14px;  border: 1px solid #7500C0 !important; border-image: none !important; height: 70%; overflow: hidden; box-shadow: -1px -1px 12px -1px #7500C0;margin-top:-2%; ">
                <!-- <canvas style="margin-top: 10%; margin-left: 5%;" class=" chart chart-doughnut" chart-data="dataDashboard" chart-labels="labelsDashboard" chart-options="options" legend="true" height="340"></canvas> -->
                <canvas style="margin-top: 0%; margin-left: 5%;" [colors]="DoughnutColors" height="340" baseChart
                    [data]="dataDashboard" [labels]="labelsDashboard" [chartType]="pieChartType" [options]="options"
                    [legend]="true"></canvas>
            </div>
        </div>
    </div>
</div>